var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4094 12.2158C18.5302 12.0967 18.5302 11.9033 18.4094 11.7842L10.6019 4.08888C10.4816 3.97037 10.2871 3.97037 10.1669 4.08888L9.09061 5.14967C8.9698 5.26875 8.9698 5.46224 9.09061 5.58132L15.4569 11.8561C15.5375 11.9355 15.5375 12.0645 15.4569 12.1439L9.09061 18.4187C8.9698 18.5378 8.9698 18.7312 9.09061 18.8503L10.1669 19.9111C10.2871 20.0296 10.4816 20.0296 10.6019 19.9111L18.4094 12.2158Z",
    fill: "#F1F4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.1808b6e5f2f73510c6e71366b2d93f47.svg";
export { ForwardRef as ReactComponent };